// Package Imports

// Project Imports
import resourceName from 'core/common/resourceName';
import ResourceItem from 'interfaces/resource';
// import ModuleIdentifierConst from 'core/common/moduleIdentifier';
import ModuleIdentifierConst from 'core/common/moduleIdentifier';

const icon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    width="25"
    height="25"
    fill="none"
    stroke="currentColor"
    strokeWidth="4.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="12" y="20" width="64" height="64" rx="12" />
    <path d="M30 32 V64 C30 74 40 78 46 72 C50 68 50 62 46 60" />
    <path d="M56 44 L70 60" />
    <path d="M70 44 L56 60" />
    <circle cx="30" cy="32" r="3.5" fill="currentColor" stroke="none" />
  </svg>
);

const HookVariableResource: ResourceItem = {
  name: resourceName.hookVariable,
  identifier: ModuleIdentifierConst.HOOK_VARIABLE,
  list: `${resourceName.hookVariable}`,
  options: { label: 'Custom Calculation Variables', icon },
  meta: {
    label: 'Custom Calculation Variables',
    icon,
    parent: resourceName.hook,
  },
};

export default HookVariableResource;
